import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { LastViewedArticle } from '../models';

@Injectable()
export class LastViewedArticlesService {
  private readonly baseUrl = '/api/medical-shop2/articles';

  constructor(private readonly http: HttpClient) {}

  /**
   * Fetches last viewed articles
   * @returns The last viewed articles
   */
  fetchLastViewedArticles(): Observable<LastViewedArticle[]> {
    return this.http.get<LastViewedArticle[]>(`${this.baseUrl}/last-viewed`);
  }

  /**
   * Marks an article as viewed
   * @param globalArticleId The Identifier of the global article
   * @returns Success info that article was marked as viewed
   */
  markArticleAsViewed(globalArticleId: string): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/mark-as-viewed`, JSON.stringify(globalArticleId), {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
}
